
export const STAGE_ROLE: Record<string, string> = {
  explore: 'explorer',
  plan: 'architect',
  code: 'coder',
  review: 'reviewer',
  test: 'tester',
  document: 'documenter'
};

export const ROLE_ICON: Record<string, { abbr: string; bg: string; fg: string }> = {
  explorer: { abbr: 'EX', bg: 'bg-role-explorer', fg: 'text-white' },
  architect: { abbr: 'AR', bg: 'bg-role-architect', fg: 'text-white' },
  coder: { abbr: 'CO', bg: 'bg-role-coder', fg: 'text-white' },
  reviewer: { abbr: 'RV', bg: 'bg-role-reviewer', fg: 'text-white' },
  tester: { abbr: 'TS', bg: 'bg-role-tester', fg: 'text-white' },
  documenter: { abbr: 'DC', bg: 'bg-role-documenter', fg: 'text-white' }
};

export const ROLE_TINT: Record<string, string> = {
  explorer: 'bg-role-explorer/[0.12] text-role-explorer',
  architect: 'bg-role-architect/[0.12] text-role-architect',
  coder: 'bg-role-coder/[0.12] text-role-coder',
  reviewer: 'bg-role-reviewer/[0.12] text-role-reviewer',
  tester: 'bg-role-tester/[0.12] text-role-tester',
  documenter: 'bg-role-documenter/[0.12] text-role-documenter'
};

export const NEUTRAL_TINT = 'bg-panel-2 text-text-muted';

export function stageTintClasses(stage_id: string | undefined): string {
  if (stage_id === undefined) return NEUTRAL_TINT;
  const role = STAGE_ROLE[stage_id];
  if (role === undefined) return NEUTRAL_TINT;
  return ROLE_TINT[role] ?? NEUTRAL_TINT;
}
